module.exports = __webpack_public_path__ + "static/img/bg-highlights-7.47a83c1c.png";